import { Spinner } from '@/components/ui/spinner';
import { toast } from '@/hooks/use-toast';
import { RedeemTokenMut } from '@/lib/api/auth/auth';
import { RoutePath } from '@/lib/routes';
import { loginWithRedeemToken, useAuthStore } from '@/store/authStore';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useMemo, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

export const RedeemTokenPage = () => {
  const auth = useAuthStore();
  const navigate = useNavigate();
  const params = useParams<{ token: string }>();
  const token = params.token;
  const redeemMut = useMutation({
    ...RedeemTokenMut(),
    onSuccess(res) {
      loginWithRedeemToken(res);
    },
    onError() {
      toast({
        title: 'Failed to redeem login token.',
      });
    },
  });
  const hasSubmitted = useRef(false);

  useEffect(() => {
    if (auth.user) {
      console.debug('Redirecting to /dashboard');
      navigate(RoutePath.Dashboard(), { replace: true });
    }
  }, [auth.user, navigate]);

  useEffect(() => {
    if (hasSubmitted.current) return;
    if (token == null) return;

    console.debug('Redeeming token...');
    redeemMut.mutate({ token });
    hasSubmitted.current = true;
  }, [hasSubmitted, redeemMut, token]);

  return (
    <div className="flex h-screen w-screen items-center justify-center">
      {redeemMut.error ? <p className="text-red-500">{redeemMut.error.message}</p> : <Spinner />}
    </div>
  );
};
